import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import SubstanceUse3 from "../Forms/B/SubstanceUse/SubstanceUse3"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const SubstanceUse3Container = ({ showToolBar, disabled, interview_id }) => {
  const {
    interview,
    handleSubmitGet,
    handleLoadPrev,
    loadCollection,
    interviewType,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [isGettingSubstanceUse, setIsGettingSubstanceUse] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingSubstanceUse(true)
      handleSubmitGet(endpoints.GET_SUBSTANCE_USE_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_3,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SUBSTANCE_USE_3
          )
          handleLoadPrev(false)
          setIsGettingSubstanceUse(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingSubstanceUse(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      ...data?.form,
      gpra_b_6: data?.form?.gpra_b_6 ?? undefined,
      gpra_b_7: loadReceivedInterventions(data?.form),
      gpra_b_7g_a: data?.form?.gpra_b_7g_a ?? "",
      gpra_b_8: data?.form?.gpra_b_8 ?? "",
      gpra_b_9: data?.form?.gpra_b_9 ?? "",
      gpra_b_10: data?.form?.gpra_b_10 ?? "",
      gpra_b_10a_a: loadNonMoodPsycoDisorders(data?.form),
      gpra_b_10a_b: loadMoodDisorders(data?.form),
      gpra_b_10a_c: loadAnxietyDisorders(data?.form),
      gpra_b_10a_d: loadObsesiveDisorders(data?.form),
      gpra_b_10a_e: loadAdjustementDisorders(data?.form),
      gpra_b_10a_f: loadBehavioralSyndroms(data?.form),
      gpra_b_10a_g: loadPersonalityDysorders(data?.form),
      gpra_b_10ab: data?.form?.gpra_b_10ab,
      gpra_b_11: interviewType !== "Intake" ? false : data?.form?.gpra_b_11,
      gpra_b_11a: interviewType !== "Intake" ? false : data?.form?.gpra_b_11a,
      gpra_b_11b: interviewType !== "Intake" ? false : data?.form?.gpra_b_11b,
      gpra_b_id: data?.form?.gpra_b_id ?? 0,
      additional: data?.additional ?? [],
    }
  }
  const loadReceivedInterventions = (data) => {
    let interventions = []
    data?.gpra_b_7a && interventions.push(data?.gpra_b_7a)
    data?.gpra_b_7b && interventions.push(data?.gpra_b_7b)
    data?.gpra_b_7c && interventions.push(data?.gpra_b_7c)
    data?.gpra_b_7d && interventions.push(data?.gpra_b_7d)
    data?.gpra_b_7e && interventions.push(data?.gpra_b_7e)
    data?.gpra_b_7f && interventions.push(data?.gpra_b_7f)
    data?.gpra_b_7g && interventions.push(data?.gpra_b_7g)
    return interventions
  }
  const loadMoodDisorders = (data) => {
    let mood = []
    data?.gpra_b_10a_b1 && mood.push(data.gpra_b_10a_b1)
    data?.gpra_b_10a_b2 && mood.push(data.gpra_b_10a_b2)
    data?.gpra_b_10a_b3 && mood.push(data.gpra_b_10a_b3)
    data?.gpra_b_10a_b4 && mood.push(data.gpra_b_10a_b4)
    data?.gpra_b_10a_b5 && mood.push(data.gpra_b_10a_b5)
    data?.gpra_b_10a_b6 && mood.push(data.gpra_b_10a_b6)
    return mood
  }
  const loadNonMoodPsycoDisorders = (data) => {
    let nonMood = []
    data?.gpra_b_10a_a1 && nonMood.push(data?.gpra_b_10a_a1)
    data?.gpra_b_10a_a2 && nonMood.push(data?.gpra_b_10a_a2)
    data?.gpra_b_10a_a3 && nonMood.push(data?.gpra_b_10a_a3)
    data?.gpra_b_10a_a4 && nonMood.push(data?.gpra_b_10a_a4)
    data?.gpra_b_10a_a5 && nonMood.push(data?.gpra_b_10a_a5)
    data?.gpra_b_10a_a6 && nonMood.push(data?.gpra_b_10a_a6)
    data?.gpra_b_10a_a7 && nonMood.push(data?.gpra_b_10a_a7)
    return nonMood
  }
  const loadAnxietyDisorders = (data) => {
    let anxiety = []
    data?.gpra_b_10a_c1 && anxiety.push(data?.gpra_b_10a_c1)
    data?.gpra_b_10a_c2 && anxiety.push(data?.gpra_b_10a_c2)
    data?.gpra_b_10a_c3 && anxiety.push(data?.gpra_b_10a_c3)
    data?.gpra_b_10a_c4 && anxiety.push(data?.gpra_b_10a_c4)
    data?.gpra_b_10a_c5 && anxiety.push(data?.gpra_b_10a_c5)
    data?.gpra_b_10a_c6 && anxiety.push(data?.gpra_b_10a_c6)
    data?.gpra_b_10a_c7 && anxiety.push(data?.gpra_b_10a_c7)
    data?.gpra_b_10a_c8 && anxiety.push(data?.gpra_b_10a_c8)
    return anxiety
  }
  const loadObsesiveDisorders = (data) => {
    let obsesive = []
    data?.gpra_b_10a_d1 && obsesive.push(data?.gpra_b_10a_d1)
    data?.gpra_b_10a_d2 && obsesive.push(data?.gpra_b_10a_d2)
    data?.gpra_b_10a_d3 && obsesive.push(data?.gpra_b_10a_d3)
    data?.gpra_b_10a_d4 && obsesive.push(data?.gpra_b_10a_d4)
    return obsesive
  }
  const loadAdjustementDisorders = (data) => {
    let adjustement = []
    data?.gpra_b_10a_e1 && adjustement.push(data?.gpra_b_10a_e1)
    data?.gpra_b_10a_e2 && adjustement.push(data?.gpra_b_10a_e2)
    data?.gpra_b_10a_e3 && adjustement.push(data?.gpra_b_10a_e3)
    data?.gpra_b_10a_e4 && adjustement.push(data?.gpra_b_10a_e4)
    data?.gpra_b_10a_e5 && adjustement.push(data?.gpra_b_10a_e5)
    data?.gpra_b_10a_e6 && adjustement.push(data?.gpra_b_10a_e6)
    data?.gpra_b_10a_e7 && adjustement.push(data?.gpra_b_10a_e7)
    return adjustement
  }
  const loadBehavioralSyndroms = (data) => {
    let behavioral = []
    data?.gpra_b_10a_f1 && behavioral.push(data?.gpra_b_10a_f1)
    data?.gpra_b_10a_f2 && behavioral.push(data?.gpra_b_10a_f2)
    return behavioral
  }
  const loadPersonalityDysorders = (data) => {
    let personality = []
    data?.gpra_b_10a_g1 && personality.push(data?.gpra_b_10a_g1)
    data?.gpra_b_10a_g2 && personality.push(data?.gpra_b_10a_g2)
    data?.gpra_b_10a_g3 && personality.push(data?.gpra_b_10a_g3)
    data?.gpra_b_10a_g4 && personality.push(data?.gpra_b_10a_g4)
    data?.gpra_b_10a_g5 && personality.push(data?.gpra_b_10a_g5)
    data?.gpra_b_10a_g6 && personality.push(data?.gpra_b_10a_g6)
    data?.gpra_b_10a_g7 && personality.push(data?.gpra_b_10a_g7)
    data?.gpra_b_10a_g8 && personality.push(data?.gpra_b_10a_g8)
    data?.gpra_b_10a_g9 && personality.push(data?.gpra_b_10a_g9)
    data?.gpra_b_10a_g10 && personality.push(data?.gpra_b_10a_g10)
    data?.gpra_b_10a_g11 && personality.push(data?.gpra_b_10a_g11)
    data?.gpra_b_10a_g12 && personality.push(data?.gpra_b_10a_g12)
    return personality
  }
  if (isGettingSubstanceUse) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingSubstanceUse && (
        <SubstanceUse3 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default SubstanceUse3Container
